export const ProposalTypeChoices = (value) => {
  switch (value) {
    case 0:
      return 'Marketing';
    case 1:
      return 'Preliminary';
    case 2:
      return 'Detailed';
    default:
      return 'N/A';
  }
};

export const ProposalStatusChoices = (value) => {
  switch (value) {
    case 0:
      return 'Requested';
    case 1:
      return 'Generated';
    default:
      return 'N/A';
  }
};

export const QuoteStatusChoices = (value) => {
  switch (value) {
    case 0:
      return 'Requested';
    case 1:
      return 'Generated';
    case 2:
      return 'Proposal Requested';
    default:
      return 'N/A';
  }
};

export const StateSelectionChoices = (value) => {
  switch (value) {
    case 0:
      return 'CA';
    case 1:
      return 'CT';
    case 2:
      return 'CO';
    case 3:
      return 'RI';
    default:
      return 'N/A';
  }
};

export const SystemTypeChoices = (value) => {
  switch (value) {
    case 0:
      return 'Rooftop';
    case 1:
      return 'GroundMount';
    case 2:
      return 'Carport';
    case 3:
      return 'Mixed';
    default:
      return 'N/A';
  }
};

export const PlatformAndDevFeeChoices = (value) => {
  switch (value) {
    case 0:
      return 'Target Profit Per Watt';
    case 1:
      return 'Given Profit Per Watt';
    case 2:
      return 'Use MarkUp Percent';
    default:
      return 'N/A';
  }
};

export const BondDiscountRateOptionsChoices = (value) => {
  switch (value) {
    case 0:
      return 'Let Model Calculate Bond Discount Rates';
    case 1:
      return 'Only Specify Roof Bond Discount Rate';
    case 2:
      return 'Specify Solar And Roof Bond Discount Rates';
    default:
      return 'N/A';
  }
};

export const systemTypes = [
  {
    value: 0,
    title: 'Rooftop',
  },
  {
    value: 1,
    title: 'GroundMount',
  },
  {
    value: 2,
    title: 'Carport',
  },
  {
    value: 3,
    title: 'Mixed',
  },
];
export const stateSelections = [
  {
    value: 0,
    title: 'CA',
  },
  {
    value: 1,
    title: 'CT',
  },
  {
    value: 2,
    title: 'CO',
  },
  {
    value: 3,
    title: 'RI',
  },
];
export const municipalitySelections = [
  'alameda',
  'butte',
  'contra_costa',
  'el_dorado',
  'fresno',
  'humboldt',
  'kern',
  'los_angeles',
  'madera',
  'mendocino',
  'merced',
  'marin',
  'monterey',
  'napa',
  'orange',
  'riverside',
  'sacramento',
  'san_benito',
  'san_bernardino',
  'san_diego',
  'san_francisco',
  'san_joaquin',
  'san_luis_obispo',
  'san_mateo',
  'santa_clara',
  'santa_cruz',
  'shasta',
  'solano',
  'sonoma',
  'stanislaus',
  'sutter',
  'tulare',
  'ventura',
  'yolo',
];
export const devFeeChoices = [
  {
    value: 0,
    title: 'Target Profit Per Watt',
  },
  {
    value: 1,
    title: 'Given Profit Per Watt',
  },
  {
    value: 2,
    title: 'Use MarkUp Percent',
  },
];
export const proposalStages = [
  {
    value: 0,
    title: 'Marketing',
  },
  {
    value: 1,
    title: 'Preliminary',
  },
  {
    value: 2,
    title: 'Detailed',
  },
];
export const bondDiscountRateOptions = [
  {
    value: 0,
    title: 'Let Model Calculate Bond Discount Rates',
  },
  {
    value: 1,
    title: 'Only Specify Roof Bond Discount Rate',
  },
  {
    value: 2,
    title: 'Specify Solar And Roof Bond Discount Rates',
  },
];
export const pricingModelOptions = [
  {
    value: 0,
    title: 'Basic pricing',
  },
  {
    value: 1,
    title: 'Clean Energy PPA',
  },
];
export const paceAdministratorOptions = [
  { value: 'WRCOG', title: 'WRCOG' },
  { value: 'CSCDA', title: 'CSCDA' },
];
export const hybridSystemTypeOptions = [
  { value: 'Tracking Groundmount', title: 'Tracking Groundmount' },
  { value: 'Fixed Groundmount', title: 'Fixed Groundmount' },
  { value: 'Rooftop', title: 'Rooftop' },
  { value: 'Canopy', title: 'Canopy' },
];
export const storageDegradationRateOptions = [
  { value: '2%', title: '2%' },
  { value: '3%', title: '3%' },
  { value: 'Tesla Powerpack 2HR', title: 'Tesla Powerpack 2HR' },
  { value: 'Tesla Powerpack 4HR', title: 'Tesla Powerpack 4HR' },
];

export const BulkEnrichmentStatusChoices = (value) => {
  switch (value) {
    case 0:
      return 'Requested';
    case 1:
      return 'Processing';
    case 2:
      return 'Generated';
    default:
      return 'N/A';
  }
};

export const PricingModelType = (value) => {
  switch (value) {
    case 0:
      return 'Clean Energy(Legacy)';
    case 1:
      return 'Clean Energy PPA';
    default:
      return 'N/A';
  }
};

export const solarUpfrontGrantUnitOptions = [
  { value: '$', title: '$' },
  { value: '$/W', title: '$/W' },
];

export const storageUpfrontGrantUnitOptions = [
  { value: '$', title: '$' },
  { value: '$/kWh', title: '$/kWh' },
];

export const irrHurdleOptions = [
  {
    value: -1,
    title: "I don't know",
  },
  {
    value: 0,
    title: 'No',
  },
  {
    value: 1,
    title: 'Yes',
  },
];

export const irrHurdleOptionChoices = (value) => {
  switch (value) {
    case -1:
      return "I don't know";
    case 0:
      return 'No';
    case 1:
      return 'Yes';
    default:
      return 'N/A';
  }
};

export const PPAModelType = (value) => {
  switch (value) {
    case 0:
      return 'Clean Energy PPA';
    case 1:
      return 'Credit PPA';
    default:
      return 'N/A';
  }
};
